var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { useModel, useModelBuilder } from '@veeam/core';
import { SplashScreenFormBody } from "../layouts/SplashScreenLayout/SplashScreenFormBody";
import { CreateUser } from './CreateUser';
import { InstanceCheck } from './InstacheCheck';
import { createUIElement } from "../helpers";
export var CreateUserSection = createUIElement('CreateUserSection', function (_a, ref) {
    var className = _a.className, icon = _a.icon, title = _a.title, loading = _a.loading, _b = _a.hasRememberMe, hasRememberMe = _b === void 0 ? true : _b, logIn = _a.logIn, _c = _a.hasInstanceCheck, hasInstanceCheck = _c === void 0 ? false : _c, instanceCheck = _a.instanceCheck, texts = _a.texts, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "icon", "title", "loading", "hasRememberMe", "logIn", "hasInstanceCheck", "instanceCheck", "texts", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var _d = useState(!!hasInstanceCheck), instanceCheckStep = _d[0], setInstanceCheckStep = _d[1];
    var busyModel = useModelBuilder({ loading: false });
    var internalLoading = useModel(busyModel).value.loading;
    loading = loading || internalLoading;
    return (React.createElement(SplashScreenFormBody, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-CreateUserSection " + className, icon: icon, title: title, content: instanceCheckStep ? (React.createElement(InstanceCheck, { loading: loading, busyModel: busyModel, send: instanceCheck, onNext: function () { return setInstanceCheckStep(false); }, texts: texts })) : (React.createElement(CreateUser, { loading: loading, hasRememberMe: hasRememberMe, texts: texts, logIn: logIn })), onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style })));
});
//# sourceMappingURL=CreateUserSection.js.map